/**
 *  포인트 발급 서치박스 label 부분 TYPE
 */
export const POINT_GENERATE_SEARCH_BOX_TYPE = {
  /**
   *  회원 번호
   */
  USER_ID: 0,
  /**
   *  전화 번호
   */
  CELLPHONE: 1,
};

/**
 *  포인트 발급 서치박스 label 부분 TEXT
 */
export const POINT_GENERATE_SEARCH_BOX_TEXT = {
  /**
   *  회원 번호
   */
  [POINT_GENERATE_SEARCH_BOX_TYPE.USER_ID]: '회원 번호',
  /**
   *  전화 번호
   */
  [POINT_GENERATE_SEARCH_BOX_TYPE.CELLPHONE]: '휴대전화 번호',
};

/**
 *  포인트 발급 서치박스 label 부분 SELECT LIST
 */
export const POINT_GENERATE_SEARCH_BOX_SELECT_LIST = [
  {
    id: POINT_GENERATE_SEARCH_BOX_TYPE.USER_ID,
    name: POINT_GENERATE_SEARCH_BOX_TEXT[POINT_GENERATE_SEARCH_BOX_TYPE.USER_ID],
  },
  {
    id: POINT_GENERATE_SEARCH_BOX_TYPE.CELLPHONE,
    name: POINT_GENERATE_SEARCH_BOX_TEXT[POINT_GENERATE_SEARCH_BOX_TYPE.CELLPHONE],
  },
];

/**
 *  포인트 내역 종류
 */
export const POINT_LOG_TYPE = {
  /**
   *  적립
   */
  SAVE: 0,
  /**
   *  사용
   */
  USE: 1,
};

export const POINT_LOG_TYPE_V2 = {
  SAVE: 'save',
  USE: 'use',
};

export const POINT_LOG_TYPE_V2_TEXT = {
  [POINT_LOG_TYPE_V2.SAVE]: '적립',
  [POINT_LOG_TYPE_V2.USE]: '사용',
};

/**
 *  포인트 내역 종류 TEXT
 */
export const POINT_LOG_TYPE_TEXT = {
  [POINT_LOG_TYPE.SAVE]: '적립',
  [POINT_LOG_TYPE.USE]: '사용',
};

/**
 *  포인트 내역 종류 SELECT LIST
 */
export const POINT_LOG_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '내역 종류 선택',
  },
  {
    id: POINT_LOG_TYPE.SAVE,
    name: POINT_LOG_TYPE_TEXT[POINT_LOG_TYPE.SAVE],
  },
  {
    id: POINT_LOG_TYPE.USE,
    name: POINT_LOG_TYPE_TEXT[POINT_LOG_TYPE.USE],
  },
];

/**
 *  point cause 환불 인덱스
 */
export const POINT_CAUSE_REFUND_INDEX = 6;

/**
 *  페이지 이름
 */
export const POINT_PAGE_NAME = {
  POINT_LIST: '포인트 내역 리스트',
  POINT_GENERATE: '포인트 발급',
  POINT_ISSUE_HISTORY_LIST: '포인트 발급 내역 리스트',
  POINT_ISSUE_HISTORY_DETAIL: '포인트 발급 내역 상세',
  POINT_RANKING: '포인트 랭킹',
  POINT_REFERRAL_ISSUE_LIST: '레퍼럴 발급 현황',
  POINT_CAUSE_LIST: '포인트 사유 리스트',
  POINT_CAUSE_CREATE: '포인트 사유 등록',
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(user)
 */
export const INVALID_GENERATE_POINT_USER_CASE_TYPE = {
  /**
   *  유효하지 않은 회원 번호
   */
  INVALID_USER_ID: 0,
  /**
   *  중복되는 유저 번호
   */
  DUPLICATE_USER_ID: 1,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(전화 번호)
 */
export const INVALID_GENERATE_POINT_CELL_PHONE_CASE_TYPE = {
  /**
   *  유효하지 않은 전화 번호
   */
  INVALID_CELL_PHONE: 0,
  /**
   *  압력된 userId 와 cellPhone 으로 얻어온 userId 가 다를때
   */
  DIFFERENCE_USER_ID: 1,
  /**
   *  해당 cellPhone 이 여러 userId 가 붙어있는 경우
   */
  DUPLICATE_CELL_PHONE: 2,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(status)
 */
export const INVALID_GENERATE_POINT_USER_STATUS_CASE_TYPE = {
  /**
   *  유효하지 않은 status
   */
  INVALID_STATUS: 0,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(type)
 */
export const INVALID_GENERATE_POINT_TYPE_CASE_TYPE = {
  /**
   *  유효하지 않은 type
   */
  INVALID_TYPE: 0,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(cause)
 */
export const INVALID_GENERATE_POINT_CAUSE_CASE_TYPE = {
  /**
   *  유효하지 않은 cause
   */
  INVALID_CAUSE: 0,
  /**
   *  해당 타입에 유효하지 않은 cause
   */
  INVALID_TYPE_TO_CAUSE: 1,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(amount)
 */
export const INVALID_GENERATE_POINT_AMOUNT_CASE_TYPE = {
  /**
   *  유효하지 않은 amount
   */
  INVALID_AMOUNT: 0,
  /**
   *  발급 할 수 있는 금액을 초과한 경우
   */
  OVER_AMOUNT: 1,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(credit)
 */
export const INVALID_GENERATE_POINT_CREDIT_CASE_TYPE = {
  /**
   *  발급하고 나서의 포인트가 음수인경우
   */
  INVALID_AFTER_CREDIT: 0,
  /**
   *  발급하고 나서의 사용한 포인트가 음수인경우
   */
  INVALID_AFTER_USED_CREDIT: 1,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(user)
 */
export const INVALID_GENERATE_POINT_USER_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 회원번호
   */
  [INVALID_GENERATE_POINT_USER_CASE_TYPE.INVALID_USER_ID]: '유효하지 않은 회원번호입니다.',
  /**
   *  중복된 회원번호
   */
  [INVALID_GENERATE_POINT_USER_CASE_TYPE.DUPLICATE_USER_ID]: '중복된 회원번호입니다.',
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(휴대전화 번호)
 */
export const INVALID_GENERATE_POINT_CELL_PHONE_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 전화 번호
   */
  [INVALID_GENERATE_POINT_CELL_PHONE_CASE_TYPE.INVALID_CELL_PHONE]: '유효하지 않은 휴대전화 번호입니다.',
  /**
   *  압력된 userId 와 cellPhone 으로 얻어온 userId 가 다를때
   */
  [INVALID_GENERATE_POINT_CELL_PHONE_CASE_TYPE.DIFFERENCE_USER_ID]:
    '입력 하신 유저 번호와 휴대전화 번호로 받아온 유저 번호가 다릅니다',
  /**
   *  해당 cellPhone 이 여러 userId 가 붙어있는 경우
   */
  [INVALID_GENERATE_POINT_CELL_PHONE_CASE_TYPE.DUPLICATE_CELL_PHONE]:
    '입력 하신 휴대전화 번호로 받아온 유저가 여러명입니다.',
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(status)
 */
export const INVALID_GENERATE_POINT_USER_STATUS_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 회원 상태
   */
  [INVALID_GENERATE_POINT_USER_STATUS_CASE_TYPE.INVALID_STATUS]: '유효하지 않은 회원 상태입니다.',
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(type)
 */
export const INVALID_GENERATE_POINT_TYPE_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 type
   */
  [INVALID_GENERATE_POINT_TYPE_CASE_TYPE.INVALID_TYPE]: '유효하지 않은 내역종류입니다.',
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(cause)
 */
export const INVALID_GENERATE_POINT_CAUSE_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 cause
   */
  [INVALID_GENERATE_POINT_CAUSE_CASE_TYPE.INVALID_CAUSE]: '유효하지 않은 적립/사용처입니다.',
  /**
   *  해당 타입에 유효하지 않은 cause
   */
  [INVALID_GENERATE_POINT_CAUSE_CASE_TYPE.INVALID_TYPE_TO_CAUSE]: '타입에 유효하지 않은 적립/사용처입니다.',
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(amount)
 */
export const INVALID_GENERATE_POINT_AMOUNT_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 amount
   */
  [INVALID_GENERATE_POINT_AMOUNT_CASE_TYPE.INVALID_AMOUNT]: '액수는 양의 숫자만 들어갈 수 있습니다.',
  /**
   *  발급 할 수 있는 금액을 초과한 경우
   */
  [INVALID_GENERATE_POINT_AMOUNT_CASE_TYPE.OVER_AMOUNT]: `최대 입력수치는 100만원 입니다.`,
};

/**
 *  포인트 발급 시 유효하지 않은 경우 타입(credit)
 */
export const INVALID_GENERATE_POINT_CREDIT_CASE_TYPE_TEXT = {
  /**
   *  발급하고 나서의 포인트가 음수인경우
   */
  [INVALID_GENERATE_POINT_CREDIT_CASE_TYPE.INVALID_AFTER_CREDIT]: '남은 포인트는 0 이상이어야 합니다.',
  /**
   *  발급하고 나서의 사용한 포인트가 음수인경우
   */
  [INVALID_GENERATE_POINT_CREDIT_CASE_TYPE.INVALID_AFTER_USED_CREDIT]: '사용된 포인트는 0 이상이어야 합니다.',
};

/**
 *  쿠폰 일괄 발급 시 유효한 경우 타입 텍스트
 */
export const VALID_GENERATE_POINT_CASE_TEXT = '포인트 발급 가능';

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입 텍스트
 */
export const INVALID_GENERATE_POINT_CASE_TEXT = '포인트 발급 불가능';

/**
 *  포인트 발급 시 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_POINT_MEMO_TEXT = 1000;

/**
 *  포인트 발급 페이지 서치 박스에서 회원번호 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID = 1000;

/**
 *  포인트 랭킹 페이지 서치 박스에서 회원 이름 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_NAME = 1000;

/**
 *  레퍼럴 발급 현황 페이지 서치 박스에서 친구 추천 코드 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_SEARCH_BOX_REFERRAL_CODE = 1000;

/**
 *  포인트 발급 페이지 서치 박스에서 input 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_SEARCH_BOX_INPUT_TEXT = 30;

/**
 *  포인트 사유 등록 페이지에서 포인트 사유 input 최대 글자수
 */
export const MAXIMUM_NUMBER_OF_POINT_CAUSE_INPUT_TEXT = 12;

/**
 *  포인트 발급 시 포인트 액수 최소 값
 */
export const MINIMUM_NUMBER_OF_AMOUNT = 0;

/**
 *  포인트 발급 시 포인트 액수 최대 값
 */
export const MAXIMUM_NUMBER_OF_AMOUNT = 1000000;

/**
 *  포인트 일반 발급 시 한번에 발급 가능한 유저 수 (일괄발급 X)
 */
export const MAXIMUM_NUMBER_OF_POINT_GENERATE_USER = 20;

/**
 *  포인트 발급 페이지 섹션 name
 */
export const POINT_GENERATE_PAGE_SECTION_NAME = {
  /**
   *  포인트 발급 대상 지정 섹션
   */
  POINT_GENERATE_SELECTED_USER_LIST: 'pointGenerateSelectedUserList',
};

/**
 *  적립금 비율 : 상품가의 1% 소수점 버림
 */
export const POINT_RATE = 0.01;

/**
 *  포인트 액션 이름
 */
export const POINT_ACTIONS_NAME = 'pointActions';
